<div class="summary-medical-order-container directory-background">
    <app-summary-order-title
        [initialLoading]="initialLoading"
        [patientData]="patient"
        [title]="title"
    ></app-summary-order-title>
    <div class="card" [ngClass]="{'android': isAndroid, 'show-footer': inWorflow}">
        <div class="order-header">
            <app-summary-order-logo
                [initialLoading]="initialLoading"
                [ubicacionFotoLogoTitulo]="history?.ubicacionFotoLogoTitulo || ''"
            ></app-summary-order-logo>
            <!--<div class="clinic-name-logo" [ngClass]="{'skeleton-item background-grey': initialLoading}"></div>-->
            <div class="title">
                <span class="bold" [ngClass]="{'skeleton-item background-grey': initialLoading}">
                    {{ requestTypeName | translate:locale.language:{requestNumber: requestNumber} }}
                </span>
                <span class="bold clinic-info-small" [ngClass]="{'skeleton-item background-grey': initialLoading}">
                    Fecha: {{dateString}}
                </span>
            </div>
        </div>
        <div class="medial-order-content" >
            <div class="location">
                <app-summary-order-patient-data
                    [initialLoading]="initialLoading"
                    [patientData]="patient"
                ></app-summary-order-patient-data>
                <app-summary-order-doctor-data
                    [ngClass]="{'d-none': initialLoading}"
                    [initialLoading]="initialLoading"
                    [empresaPortal]="history?.empresaPortal"
                    [esProfesionalVerificado]="summaryOrderSignComponent?.esProfesionalVerificado || true"
                    [publicProfile]="publicProfile"
                ></app-summary-order-doctor-data>
                <mat-divider class="mat-divider mat-divider-horizontal w-100" role="separator"></mat-divider>
            </div>
            <div *ngIf="diagnosticos.length && !initialLoading" class="diagnosticos-container">
                <span class="diagnosticos">
                    <span class="titulo">{{'shared.medicalOrder.summary.' + diagnosticosLabel | translate:locale.language}}:</span>
                    {{diagnosticos}}
                </span>
            </div>
            <ol *ngIf="!initialLoading" [ngClass]="{'sin-numeros': showNumbers()}">
                <li *ngFor="let item of atenciones; let i = index" class="subitems">
                    <span>
                        <span>{{item.nombreConcepto || item.nombreConceptoClinico}}</span>
                        <span *ngIf="item.cantidad"> (Total: #{{item.cantidad}})</span>
                        <br *ngIf="item.valorConcepto" />
                        <app-summary-order-concept-value *ngIf="item.valorConcepto" [item]="item"></app-summary-order-concept-value>
                    </span>
                    <ul *ngIf="item.items" class="subitem" [ngClass]="{'d-none': !item.items.length}">
                        <li *ngFor="let item2 of item.items" [ngClass]="{'skeleton-item background-grey': initialLoading}">
                            {{item2.nombreConcepto || item2.nombreConceptoClinico}}<br *ngIf="item2.valorConcepto" />
                            <span *ngIf="item2.valorConcepto">{{item2.valorConcepto}}</span>
                        </li>
                    </ul>
                </li>
            </ol>
            <div *ngIf="comentarios || initialLoading" class="comentarios">
                <div class="titulo" [ngClass]="{'skeleton-item background-grey': initialLoading}">
                    {{'shared.medicalOrder.summary.comment' | translate:locale.language}}
                </div>
                <div class="comentario" [ngClass]="{'skeleton-item background-grey': initialLoading}" *ngIf="!showHtmlComment || initialLoading">
                    {{comentarios?.valorConcepto}}
                </div>
                <div class="comentario-html" [ngClass]="{'skeleton-item background-grey': initialLoading}" *ngIf="showHtmlComment || initialLoading" [innerHtml]="htmlComment"></div>
            </div>
            <app-summary-order-sign
                [initialLoading]="initialLoading"
                [idResponsableServicio]="history.solicitud.idResponsableServicio"
            ></app-summary-order-sign>
        </div>
        <div class="summary-order-footer-container" *ngIf="!initialLoading">
            <button mat-button mat-flat-button class="secondary" (click)="irInicio()" *ngIf="inWorflow">
                {{ buttonSecondaryText | translate:locale.language }}
            </button>
            <button mat-button mat-flat-button class="primary" (click)="verOrdenes()" *ngIf="inWorflow">
                <span> {{ buttonPrimaryText | translate:locale.language }} </span>
            </button>
            <button mat-button mat-flat-button class="primary download-button" 
                *ngIf="!inWorflow" 
                [ngClass]="{'loading': downloading, 'skeleton-item background-grey': loadingFile }" 
                (click)="descargarOrden()">
                <img src="assets/images/file_download.svg" />
                <span> {{ 'shared.medicalOrder.summary.buttonDownloadOrder' | translate:locale.language }} </span>
            </button>
            <button mat-button mat-flat-button class="primary download-button" 
                *ngIf="!inWorflow && file" 
                [ngClass]="{'loading': sharing, 'skeleton-item background-grey': loadingFile }" 
                (click)="compartirOrden()">
                <mat-icon fontSet="phr-iconset" class="icon phr-iconset-share"></mat-icon> 
                <span> {{ 'shared.medicalOrder.summary.buttonShareOrder' | translate:locale.language }} </span>
            </button>            
        </div>
    </div>
</div>